export const search_item = (data) => {
    return `<a class='search-result' href="${data.absolute_url}">
        <h6> ${data.title} </h6>
        ${data.address ? `<p class="search-result-address">${data.address}</p>` : `<p class="search-result-address">Адрес не указан</p>`} 
    </a>`
}
export const search_empty = () => {
    return `<div class='search-result'>Ничего не найдено</div>`
}